import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const calendarLocaleModule: LocaleModule = {
  name: "calendar",
  messages: { en: en, it: it },
};
